import React, { Component, PropTypes } from 'react';
import Facebook from '../icons/Facebook';
import Twitter from '../icons/Twitter';
import Email from '../icons/Email';
import Google from '../icons/Google';
import Instagram from '../icons/Instagram';
import Reddit from '../icons/Reddit';
import Snapchat from '../icons/Snapchat';
import Pinterest from '../icons/Pinterest';
import LinkedIn from '../icons/LinkedIn';

const SocialIconList = {
  facebook: <Facebook/>,
  twitter: <Twitter/>,
  email: <Email/>,
  emailaddress: <Email/>,
  google: <Google/>,
  instagram: <Instagram/>,
  reddit: <Reddit/>,
  snapchat: <Snapchat/>,
  pinterest: <Pinterest/>,
  linkedin: <LinkedIn/>
};

class SocialIcon extends Component {
  static propTypes = {
    iconType: PropTypes.string,
    destinationUri: PropTypes.string,
    noTarget: PropTypes.bool
  };

  static defaultProps = {
    iconType: '',
    destinationUri: '',
    noTarget: false
  }

  render() {
    const { iconType, destinationUri, noTarget } = this.props;

    return (
      <div className='SocialIcon'>
        <a href={destinationUri}
           className='SocialIcon-link'
           target={noTarget ? '' : '_blank'}
           rel={noTarget ? '' : 'noopener noreferrer'}
        >
          {SocialIconList[iconType.toLowerCase()] || null}
        </a>
      </div>
    );
  }
}

export default SocialIcon;



// WEBPACK FOOTER //
// ./app/components/social/SocialIcon.js